import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f457bfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-main" }
const _hoisted_2 = {
  key: 0,
  class: "pc-wrap"
}
const _hoisted_3 = { class: "main-container" }
const _hoisted_4 = {
  key: 1,
  class: "phone-wrap"
}

import { computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import checkPc from '@/utils/checkPc';
import { storeToRefs } from 'pinia'
import { useUserStoreHook } from "@/store/modules/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  parent: {
    type: Boolean,
    default: true
  },
  footer: {
    type: Boolean,
    default: true
  },

  //  移动端
  bg: {
    type: String,
    default: ''
  },
  showTitle: {
    type: Boolean,
    default: true
  },
  pageName: {
    type: String,
    default: ''
  },
  showBack: {
    type: Boolean,
    default: true
  },
  backCallback: {
    type: Function,
    default: undefined
  },
},
  setup(__props) {

const route = useRoute()

const userStore = useUserStoreHook()
const { userInfo, inviteInfo } = storeToRefs(userStore)

// 引入组件
const HeaderApp = defineAsyncComponent(() => import('./HeaderApp.vue'));
const FooterApp = defineAsyncComponent(() => import('./FooterApp.vue'));
const Phone = defineAsyncComponent(() => import('./phone/index.vue'));
const InviteView = defineAsyncComponent(() => import('@/components/Invite/index.vue'));
const AdvertView = defineAsyncComponent(() => import('@/components/Advert/index.vue'));

const props = __props

const showFooter = () => {
  return props.footer && route.path.includes('home')
}

const showTopNav = computed(() => {
  return !!route.meta.showTopNav
})

const showInvite = computed(() => {
  if (inviteInfo.value?.status == 1 && userInfo.value.token && (!route.path.includes('member') || route.path == '/member/join')) return true
  return false
})

/**
 * 判断是否PC端
 */
const isPC = checkPc();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isPC))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(HeaderApp)),
          _createElementVNode("div", _hoisted_3, [
            (__props.parent)
              ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
              : _renderSlot(_ctx.$slots, "default", { key: 1 }),
            (showFooter())
              ? (_openBlock(), _createBlock(_unref(FooterApp), { key: 2 }))
              : _createCommentVNode("", true)
          ]),
          (showInvite.value)
            ? (_openBlock(), _createBlock(_unref(InviteView), { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_unref(AdvertView))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(Phone), {
            parent: __props.parent,
            bg: __props.bg,
            showTitle: __props.showTitle,
            pageName: __props.pageName,
            "show-back": __props.showBack,
            backCallback: __props.backCallback,
            showTopNav: showTopNav.value
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default"),
              (showFooter())
                ? (_openBlock(), _createBlock(_unref(FooterApp), { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["parent", "bg", "showTitle", "pageName", "show-back", "backCallback", "showTopNav"]),
          _createVNode(_unref(AdvertView))
        ]))
  ]))
}
}

})